import { render } from "./tabFleetList.vue?vue&type=template&id=8779ed06&scoped=true"
import script from "./tabFleetList.vue?vue&type=script&lang=js"
export * from "./tabFleetList.vue?vue&type=script&lang=js"

import "./tabFleetList.vue?vue&type=style&index=0&id=8779ed06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8779ed06"]])